import { useTranslation } from '@platform/i18n';
import { BookOpen, CircleHelp, MessageCircle, PlayCircle, type LucideIcon } from 'lucide-react';
import { useState } from 'react';
import { useSupportLinks } from './support.tsx';
import styles from './Shell.module.css';

type HelpLink = {
  readonly id: string;
  readonly href: string;
  readonly labelKey: string;
  readonly hintKey: string;
  readonly icon: LucideIcon;
};

export const HelpMenu = () => {
  const { t } = useTranslation();
  const support = useSupportLinks();
  const [open, setOpen] = useState(false);
  if (support.mode === 'none') return null;
  const links: readonly HelpLink[] = [
    {
      id: 'whatsapp',
      href: support.whatsappUrl,
      labelKey: 'shell.helpWhatsapp',
      hintKey: 'shell.helpWhatsappHint',
      icon: MessageCircle,
    },
    {
      id: 'guides',
      href: support.guidesUrl,
      labelKey: 'shell.helpGuides',
      hintKey: 'shell.helpGuidesHint',
      icon: PlayCircle,
    },
    {
      id: 'center',
      href: support.helpCenterUrl,
      labelKey: 'shell.helpCenter',
      hintKey: 'shell.helpCenterHint',
      icon: BookOpen,
    },
  ];
  return (
    <div className={styles['help']}>
      <button
        type="button"
        className={styles['navLink']}
        aria-label={t('shell.help')}
        aria-expanded={open}
        onClick={() => {
          setOpen((current) => !current);
        }}
      >
        <CircleHelp size={20} aria-hidden="true" className={styles['navIcon']} />
        <span className={styles['navLabel']}>{t('shell.help')}</span>
      </button>
      {open ? (
        <div className={styles['helpMenu']} role="menu" aria-label={t('shell.help')}>
          {links.map((link) => (
            <a
              key={link.id}
              role="menuitem"
              className={styles['helpLink']}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles['helpIcon']} aria-hidden="true">
                <link.icon size={16} />
              </span>
              <span>
                {t(link.labelKey)}
                <small className={styles['helpHint']}>{t(link.hintKey)}</small>
              </span>
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
};
